
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class RadarSweepEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;
        const radius = Math.min(width, height) * 0.8 * scale;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const draw = () => {
             // Main Circle
             ctx.beginPath();
             ctx.arc(0, 0, radius, 0, Math.PI * 2);
             ctx.stroke();

             // Grid lines
             ctx.save();
             ctx.globalAlpha *= 0.2;
             for (let i = 0; i < 4; i++) {
                 ctx.beginPath();
                 ctx.arc(0, 0, radius * (i + 1) / 4, 0, Math.PI * 2);
                 ctx.stroke();
             }
             ctx.beginPath();
             ctx.moveTo(-radius, 0); ctx.lineTo(radius, 0);
             ctx.moveTo(0, -radius); ctx.lineTo(0, radius);
             ctx.stroke();
             ctx.restore();

             // Sweep
             const sweepAngle = curTime;
             const grad = ctx.createConicGradient(sweepAngle, 0, 0);
             grad.addColorStop(0, pc.color);
             grad.addColorStop(0.2, 'transparent');
             ctx.fillStyle = grad;
             ctx.save();
             ctx.globalAlpha *= 0.4;
             ctx.beginPath();
             ctx.moveTo(0, 0);
             ctx.arc(0, 0, radius, sweepAngle - 0.5, sweepAngle);
             ctx.fill();
             ctx.restore();

             // Blips
             ctx.fillStyle = pc.color;
             for (let i = 0; i < 3; i++) {
                 const bx = (this.pseudoRandom(i) - 0.5) * radius * 1.5;
                 const by = (this.pseudoRandom(i + 10) - 0.5) * radius * 1.5;
                 const fade = (Math.sin(curTime * 2 + i) + 1) * 0.5;
                 ctx.globalAlpha = fade;
                 ctx.beginPath();
                 ctx.arc(bx, by, 5 * scale, 0, Math.PI * 2);
                 ctx.fill();
             }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
